<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center m-3 globalborder-btm-header pb-2">
        <span class="col-auto">
          <h2 class="mb-0">CDI Resolution Summary</h2>
        </span>

        <span>
          <span class="cross-border" (click)="closeModal()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="p-3 adduser-container-hgt">
        <div class="cdiresolutionsummary" [ngClass]="'splitlayout'">
          <div class="content">
            <div class="row">
              <div class="col-md-8">
                <jni-cdi-header
                  [CDIResolutionNumber]="CDIResolutionNumber"
                  [poNumber]="poNumber"
                  [saleOrderId]="saleOrderId"
                  [vendorName]="vendorName"
                  [vendorNumber]="vendorNumber"
                  [cdi]="cdi"
                  [reason]="reason"
                  [jobNameHeader]="jobNameHeader"
                  [customerName]="customerName"
                  [cdiActionVal]="cdiActionVal"
                  [recId]="recId"
                  [isDisableSubmit]="isDisableSubmit"
                  [tableId]="tableId"
                  [cdiRecId]="cdiRecId"
                  [diff]="invoiceEmailListing[0].diff"
                  (getCdiSummaryEvent)="getCdiSummary($event)"
                  [quickQuoteValue]="quickQuoteValue"
                  (submitQuickNoteAPIEvent)="submitQuickNoteAPIEvent()"
                  (quickNoteMandatoryEvent)="quickNoteMandatoryEvent($event)"
                  [isFromIRScreen]="isFromIRScreen">
                </jni-cdi-header>

                <jni-cdi-notes
                  #cdiNotes
                  [cdiNotesGridListing]="cdiNotesGridListing"
                  [saleOrderId]="saleOrderId"
                  [poNumber]="poNumber"
                  [recId]="recId"
                  (quickNoteChangeEvent)="quickNoteChangeEvent($event)"
                  (refreshNotesGrid)="getCDINotes($event)">
                </jni-cdi-notes>

                <div class="cdirestable">
                  <!-- <jni-cdi-lines
                    #linesComponent
                    [cdiLinesGridListing]="cdiLinesGridListing"
                    [OrderLineId]="saleOrderId"
                    [inputPoNumber]="poNumber"
                    (copyLinesEvent)="showCopyLineModalDialog($event)"
                    (refrestDataEvent)="refreshGrid()"
                    (gridRefresh)="refreshPage(true)"
                    (gridSaveAndUpdateEvent)="saveAndUpdateCdiGrid($event)"
                    (scrollHiddenStatus)="addScollHiddenClass()">
                  </jni-cdi-lines> -->
                  <jni-order-summary-line-items
                    [salesOrderLine]="salesOrderLine"
                    [OrderLineId]="saleOrderId"
                    [currencyConversion]="currencyConversion"
                    [foreignCurrency]="foreignCurrency"
                    [releasedProductsList]="releasedProductsList"
                    [salesOrderLines]="salesOrderLine"
                    [purchaseOrderIdList]="purchaseOrderIdList"
                    [smallLoader]="smallLoader"
                    [salesOrderStatusD365]="salesOrderStatusD365"
                    [approvalStatusD365]="approvalStatusD365"
                    [isSaleOrderLineConfirmStatus]="
                      isSaleOrderLineConfirmStatus
                    "
                    [avaiableCredit]="avaiableCredit"
                    [subtotalForCreditLimitCheck]="subtotalForCreditLimitCheck"
                    [getAvailableCreditBtnStatus]="getAvailableCreditBtnStatus"
                    [saleOrderModalStatus]="saleOrderModalStatus"
                    [userBlockedFromEdit]="userBlockedFromEdit"
                    [isCdi]="true"
                    [cdiRecId]="cdiRecId"
                    [linesVendorNumber]="linesVendorNumber"
                    (changeDetect)="refreshPage($event)"
                    (gridRefresh)="refreshPage(true)"
                    (getPoListEvent)="callgetPurchaseOrderId($event)"
                    (scrollHiddenStatus)="addScollHiddenClass()"
                    (calculateSubtotalsAndNet)="netAndSubtotalChanged()"
                    [hideButtonsOnPageLoad]="hideButtonsOnPageLoad"
                    [saleOrderData]="saleOrderData">
                  </jni-order-summary-line-items>
                </div>
              </div>
              <div class="col-md-4">
                <div class="cdi-total-panel">
                  <p-table
                    #dt
                    responsiveLayout="scroll"
                    [value]="invoiceEmailListing"
                    styleClass="p-datatable-customers ordersListing search-more"
                    [rowHover]="true"
                    [rows]="250"
                    [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
                    [paginator]="false"
                    [filterDelay]="0"
                    className="tableblueheader">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>&nbsp;</th>
                        <th class="number">JNI</th>
                        <th class="status">Vendor</th>
                        <th class="name">Diff</th>
                      </tr>
                    </ng-template>
                    <ng-template
                      pTemplate="body"
                      let-invoiceEmailListing
                      let-rowIndex="rowIndex">
                      <tr
                        class="p-selectable-row colored-gray"
                        [pSelectableRow]="invoiceEmailListing"
                        [pSelectableRowIndex]="rowIndex">
                        <td class="number">Subtotals :</td>
                        <td class="number">
                          {{
                            invoiceEmailListing.jniSubTotal
                              | currency: "USD" : "symbol" : "0.2-2"
                          }}
                        </td>
                        <td class="status">
                          {{
                            invoiceEmailListing.vendorSubTotal
                              | currency: "USD" : "symbol" : "0.2-2"
                          }}
                        </td>
                        <td class="name">
                          <span class="highlightred delcol"
                            ><b>{{
                              invoiceEmailListing.diff
                                | currency: "USD" : "symbol" : "0.2-2"
                            }}</b></span
                          >
                        </td>
                      </tr>
                      <tr
                        class="p-selectable-row colored-green"
                        [pSelectableRow]="invoiceEmailListing"
                        [pSelectableRowIndex]="rowIndex">
                        <td class="number">
                          <b>Vendor Tax :</b>
                        </td>
                        <td class="number">
                          <b>{{
                            invoiceEmailListing.vendorTax
                              | currency: "USD" : "symbol" : "0.2-2"
                          }}</b>
                        </td>
                        <td class="status"><b>Vendor Frt :</b></td>
                        <td class="name">
                          <span
                            ><b>{{
                              invoiceEmailListing.vendorFrt
                                | currency: "USD" : "symbol" : "0.2-2"
                            }}</b></span
                          >
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="20">No invoice email found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
                <!-- <iframe [src]="poJournalPdf"></iframe> -->
                <div class="fixpdfsectionview">
                  <ngx-extended-pdf-viewer
                    [base64Src]="poJournalPdf"
                    [textLayer]="true"
                    [showHandToolButton]="true"
                    [showPresentationModeButton]="true"
                    [zoom]="'auto'">
                  </ngx-extended-pdf-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-samplepo-copy-lines
  #copyline
  [displayModal]="displayCopyLineModel"
  [samplePONumber]="poNumber"
  (refreshGridEvent)="refreshGrid()"
  (closeDialogEvent)="closeModalDialog()"
  (changeDetect)="refreshPage(true)">
</jni-samplepo-copy-lines>
